import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { MasterService } from '../../../master/services/master.service';
import { bankAccountOptions, EntityFormOption } from '../../entity-form/entity-form.utils';

@Injectable({ providedIn: 'root' })
export class LoanFormLookupsFacade {

  constructor(private masterService: MasterService) { }

  bankAccounts(): Promise<EntityFormOption[]> {
    return firstValueFrom(this.masterService.getBankAccounts()).then(list => bankAccountOptions(list));
  }
}
